import { content as terminContent } from '../../../utils';

export const content = {
  ...terminContent,
  draggableId: 'zeitlicherablauf',
  heading: 'Zeitlicher Ablauf',
  fields: {
    ablauf: 'Ablauf',
    zusatzinfo: 'Zusatzinfo',
  },
} as const;
